import StaffMessaging from "@/components/messaging/StaffMessaging";

export default function SecretaryMessaging() {
  return <StaffMessaging defaultRecipientType="patient" />;
}
